<template>
  <div>
    <md-steppers :md-active-step.sync="active" md-linear v-if="!loading && !canAnswerQuestionnaireTest">
      <md-step id="first" :md-label="$t('the_questionnaire')" :md-description="$t('how_to_get_the_most_out_of_the_questionnaire')" :md-editable="false" :md-done.sync="first" class="pt-5">
        <h6 class="text-left font-weight-bold">{{$t('how_to_get_the_most_out_of_the_questionnaire')}}</h6><br>
        <h6 class="text-left font-weight-bold">{{$t('the_questionnaire_sentence1')}}</h6>
        <p class="text-left">{{$t('the_questionnaire_sentence2')}}</p>
        <h6 class="font-weight-bold">{{$t('here_are_suggestions_for_improving_the_accuracy_of_your_answers')}}</h6>
        <ul class="text-left">
          <li>{{$t('the_questionnaire_sentence3')}}</li>
          <li>{{$t('the_questionnaire_sentence4')}}</li>
          <li>{{$t('the_questionnaire_sentence5')}}</li>
          <li>{{$t('the_questionnaire_sentence6')}}</li>
          <li>{{$t('the_questionnaire_sentence7')}}</li>
        </ul>
        <button @click="playVideo();setDone('first', 'second')" target="_blank" class="btn-rounded btn btn-info btn-sm ripple-parent">{{$t('continue')}}</button>
      </md-step>
      <md-step id="second" :md-label="$t('precautions')" :md-description="$t('how_do_i_answer_the_questionnaire')" :md-editable="false" :md-done.sync="second" class="pt-5">
        <video controls class="video-border" id="video_instruction">
          <source src="https://gestion.comcolors.com/videos/questionnaire.mp4" type="video/mp4">
          Your browser does not support HTML5 video.
        </video>
        <br><br>
        <h6 class="text-left font-weight-bold">{{$t('how_do_i_answer_the_questionnaire')}}</h6>
        <ul class="text-left">
          <li>{{$t('precautions_sentence1')}}</li>
          <li>{{$t('precautions_sentence2')}}</li>
          <li><strong>{{$t('precautions_sentence3')}}</strong></li>
          <li>{{$t('precautions_sentence4')}}</li>
        </ul>
        <p class="text-left">{{$t('precautions_sentence5')}}</p>
        <p class="text-left"><strong>{{$t('technical_note')}}</strong>: {{$t('precautions_sentence6')}} <a href="http://windowsupdate.microsoft.com/" target="_blank">{{$t('windows_update')}}</a>. {{$t('precautions_sentence7')}} <a href="http://www.mozilla.com/en-US/" target="_blank">{{$t('download')}}</a> {{$t('precautions_sentence8')}}</p>
        <button v-if="videoWatchedEnd == false" @click="showDialogInstruction = true" class="btn-rounded btn btn-info btn-sm ripple-parent">{{$t('start_the_questionnaire')}}</button>
        <button v-if="videoWatchedEnd == true" @click="questionnaire" class="btn-rounded btn btn-info btn-sm ripple-parent">{{$t('start_the_questionnaire')}}</button>
      </md-step>
    </md-steppers>
    <div v-if="!loading && canAnswerQuestionnaireTest">
      <br>
      <h6 class="text-left font-weight-bold">{{$t('how_do_i_answer_the_questionnaire')}}</h6>
      <p class="text-left">{{$t('txt_intro_accept_questionnaire_test1')}}</p>
      <p class="text-left">{{$t('txt_intro_accept_questionnaire_test2')}}</p>
      <p class="text-left">{{$t('txt_intro_accept_questionnaire_test3')}}</p>
      <button class="btn-rounded btn btn-info btn-sm ripple-parent" @click="questionnaire">{{$t('start_the_questionnaire')}}</button>
    </div>
    <div>
      <md-dialog :md-active.sync="showConfirmReadVideo">
        <md-dialog-title>{{$t('question_view_video')}}</md-dialog-title>
        <md-dialog-actions>
          <md-button class="md-primary" @click="showConfirmReadVideo = false; showDialogInstruction = true;">{{$t('no_view_video')}}</md-button>
          <md-button class="md-primary" @click="questionnaire">{{$t('yes_view_video')}}</md-button>
        </md-dialog-actions>
      </md-dialog>

      <md-dialog :md-active.sync="showDialogInstruction">
        <p style="margin: 15px; font-size: 16px;">{{$t('resume_video_instructions')}}</p>
        <md-dialog-actions>
          <md-button class="md-primary start-question" @click="questionnaire">{{$t('start_the_questionnaire')}}</md-button>
        </md-dialog-actions>
      </md-dialog>
    </div>
  </div>
</template>

<script>

import {getLoggedUser, isVenteApp} from '../services/User.service'
import { mapGetters } from 'vuex'

export default {
    name: 'QuestionnaireInstructions',
    data: () => ({
      active: 'first',
      first: false,
      second: false,
      showConfirmReadVideo: false,
      showDialogInstruction: false,
      videoWatchedEnd: false,
      windowWidth: 0,
      windowHeight: 0,
      loading: false,
      userDetails: {
        hasAcceptTest: false,
        hasAcceptTestDate: '',
        repondu_test: '',
      },
    }),
    methods: {
      setDone (id, index) {
        this[id] = true
        if (index) {
          this.active = index
          this.backToTop();
        }
      },
      questionnaire(){
        this.$router.push({path:'questionnaire'});
      },
      playVideo() {
        document.getElementById('video_instruction').play();
        const video = document.getElementById('video_instruction');

        video.addEventListener('ended', (event) => {
            this.videoWatchedEnd = true;
        });
      },
      getWindowWidth(event) {
        this.windowWidth = document.documentElement.clientWidth;
      },
      getWindowHeight(event) {
        this.windowHeight = document.documentElement.clientHeight;
      },
      backToTop(){
        $('html,body').stop().animate({
            scrollTop: 0
        }, 'slow', 'swing');
      },
      getUserData(){
        if(localStorage.getItem('userId')) {
          this.loading = true;
          this.userDetails.hasAcceptTest = this.currentUser.has_accept_test
          this.userDetails.hasAcceptTestDate = this.currentUser.has_accept_test_date
          this.userDetails.repondu_test = this.currentUser.questionnaire_repondu.repondu_test
          this.loading = false;
        }
      }
    },
    computed:{
      ...mapGetters(['currentUser']),
      canAnswerQuestionnaireTest(){
        return (this.userDetails.hasAcceptTest == true && this.userDetails.hasAcceptTestDate != '' && (this.userDetails.repondu_test == '' || this.userDetails.repondu_test == null) && !isVenteApp());
      }
    },
    watch: {
      '$route': ['getUserData']
    },
  async mounted() {
        this.getUserData();
        this.$nextTick(function() {
        window.addEventListener('resize', this.getWindowWidth);
        window.addEventListener('resize', this.getWindowHeight);

        //Init
        this.getWindowWidth()
        this.getWindowHeight()
        })
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.getWindowWidth);
        window.removeEventListener('resize', this.getWindowHeight);
    }
}
</script>

<style lang="css" scoped>
.video-border {
width: 50%;
border: 5px solid #33b5e5;
}
@media (max-width: 768px) {
.video-border {
width: 100%;
}
}
.md-dialog {
  max-width: 587px;
  border: 4px solid #33b5e5;
  -webkit-border-radius: 12px;
  -moz-border-radius: 12px;
  border-radius: 12px;
  box-shadow: 2px 2px 6px rgba(0,0,0,0.6);
}

.start-question {
  margin-right: 30%;
}
</style>



// WEBPACK FOOTER //
// src/components/Instructions.vue